export const MAX_FILE_SIZE = 6 * 1024 * 1024;
export const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/webp"];

export const AmenityRules = {
  title: [
    { rule: "required", label: "Title" },
    { rule: "minLength", value: 2, label: "Title" },
    { rule: "maxLength", value: 100, label: "Title" },
  ],
  description: [
    { rule: "optional", label: "Description" },
    { rule: "maxLength", value: 1000, label: "Description" },
  ],

  sort_order: [
    { rule: "optional", label: "Sort Order" },
    { rule: "number", label: "Sort Order" },
    { rule: "min", value: 0, label: "Sort Order" },
  ],
  is_active: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: [0, 1, "0", "1"], label: "Status" },
  ],
  features: [{ rule: "optional", label: "Features" }],
};

export const UserEditRules = {
  firstname: [
    { rule: "required", label: "First Name" },
    { rule: "minLength", value: 3, label: "First Name" },
    { rule: "stringOnly", label: "First Name" },
  ],
  lastname: [
    { rule: "required", label: "Last Name" },
    { rule: "minLength", value: 3, label: "Last Name" },
    { rule: "stringOnly", label: "Last Name" },
  ],
  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
  ],
  password: [
    { rule: "password", label: "Password" }, // Optional: only validate if not empty
  ],
  image: [
    { rule: "file", optional: true, maxSize: MAX_FILE_SIZE, label: "Image" },
  ],
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: [0, 1], label: "Status" },
  ],
  about: [
    { rule: "minLength", value: 5, label: "About" },
    { rule: "maxLength", value: 255, label: "About" },
  ],
};

export const UserAddRules = {
  firstname: [
    { rule: "required", label: "First Name" },
    { rule: "minLength", value: 3, label: "First Name" },
    { rule: "stringOnly", label: "First Name" },
  ],
  lastname: [
    { rule: "required", label: "Last Name" },
    { rule: "minLength", value: 3, label: "Last Name" },
    { rule: "stringOnly", label: "Last Name" },
  ],
  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
  ],
  password: [
    { rule: "required", label: "Password" },
    { rule: "password", label: "Password" },
  ],
  image: [
    { rule: "file", optional: true, maxSize: MAX_FILE_SIZE, label: "Image" },
  ],
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: [0, 1], label: "Status" },
  ],
  about: [
    { rule: "minLength", value: 5, label: "About" },
    { rule: "maxLength", value: 255, label: "About" },
  ],
};

export const BrandLogoRules = {
  brand_name: [
    { rule: "required", label: "Brand Name" },
    { rule: "minLength", value: 2, label: "Brand Name" },
  ],
  brand_logo: [
    {
      rule: "file",
      optional: true,
      label: "Brand Logo",
      accept: ["image/png", "image/jpeg", "image/jpg"],
      maxSize: 1024 * 6000, // optional - 6MB
    },
  ],
};

export const HeroSectionRules = {
  badge: [
    { rule: "required", label: "Badge" },
    { rule: "minLength", value: 2, label: "Badge" },
  ],
  title: [
    { rule: "required", label: "Title" },
    { rule: "minLength", value: 3, label: "Title" },
  ],
  subtitle: [
    { rule: "required", label: "Subtitle" },
    { rule: "minLength", value: 3, label: "Subtitle" },
  ],
  button_text: [
    { rule: "required", label: "Button Text" },
    { rule: "minLength", value: 2, label: "Button Text" },
  ],
  button_link: [
    { rule: "required", label: "Button Link" },
    { rule: "minLength", value: 2, label: "Button Link" },
  ],
  stats_suites: [{ rule: "optional", label: "Suites Stat" }],
  stats_awards: [{ rule: "optional", label: "Awards Stat" }],
  is_active: [{ rule: "required", label: "Status" }],
  background_image: [
    {
      rule: "file",
      optional: true,
      label: "Background Image",
      accept: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
      maxSize: 1024 * 6000,
    },
  ],
};

export const TeamRules = {
  name: [
    { rule: "required", label: "Name" },
    { rule: "minLength", value: 3, label: "Name" },
    { rule: "stringOnly", label: "Name" },
  ],
  position: [
    { rule: "required", label: "Position" },
    { rule: "minLength", value: 3, label: "Position" },
    { rule: "stringOnly", label: "Position" },
  ],
  photograph: [
    {
      rule: "file",
      optional: true,
      label: "Photograph",
      accept: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
      maxSize: 1024 * 500, // 500 KB
    },
  ],
};

export const GalleryRules = {
  title: [
    { rule: "required", label: "Title" },
    { rule: "minLength", value: 2, label: "Title" },
  ],
  category: [
    { rule: "required", label: "Category" },
    { rule: "minLength", value: 2, label: "Category" },
  ],
  image: [
    {
      rule: "file",
      optional: true,
      label: "Image",
      accept: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
      maxSize: 1024 * 500, // 500 KB
      // Optionally you can add width/height ratio validation later
    },
  ],
};

export const ContactInformationRules = {
  label: [{ rule: "required", label: "Label" }],
  details: [{ rule: "required", label: "Details" }],
};

export const FoodTypeRules = {
  food_type_name: [
    { rule: "required", label: "Food Categories" },
    { rule: "stringOnly", label: "Food Categories" },
    { rule: "minLength", value: 2, label: "Food Categories" },
    { rule: "maxLength", value: 100, label: "Food Categories" },
  ],
  description: [
    { rule: "required", label: "Description" },
    { rule: "minLength", value: 5, label: "Description" },
    { rule: "maxLength", value: 255, label: "Description" },
  ],
};

export const RoomFeatureRules = {
  name: [
    { rule: "required", label: "Feature Name" },
    { rule: "minLength", value: 2, label: "Feature Name" },
  ],
  description: [
    { rule: "required", label: "Description" },
    { rule: "minLength", value: 5, label: "Description" },
  ],
  status: [{ rule: "enum", values: ["0", "1"], label: "Status" }],
};

export const SocialLinkRules = {
  name: [
    {
      rule: "required",
      label: "Name",
    },
    {
      rule: "minLength",
      label: "Name",
      value: 2,
    },
  ],
  link_url: [
    {
      rule: "required",
      label: "URL",
    },
    {
      rule: "minLength",
      label: "URL",
      value: 5,
    },
  ],
  icon: [
    {
      rule: "file",
      label: "Icon",
      accept: ["image/png", "image/jpg", "image/jpeg", "image/svg+xml"],
      optional: true,
    },
  ],
};

export const TermsAndPrivacyRules = {
  title: [
    { rule: "required", label: "Title" },
    { rule: "minLength", label: "Title", value: 3 },
  ],
  name: [
    { rule: "required", label: "Name" },
    { rule: "minLength", label: "Name", value: 2 },
  ],
};

export const RoleRules = {
  role_name: [
    { rule: "required", label: "Role Name" },
    { rule: "minLength", value: 2, label: "Role Name" },
    { rule: "stringOnly", label: "Role Name" },
  ],
  role_description: [
    { rule: "required", label: "Role Description" },
    { rule: "minLength", value: 4, label: "Role Description" },
    { rule: "stringOnly", label: "Role Description" },
  ],
  role_status: [
    { rule: "required", label: "Role Status" },
    { rule: "enum", values: [0, 1], label: "Role Status" },
  ],
};

export const MenuRules = {
  menu_name: [
    { rule: "required", label: "Menu Name" },
    { rule: "minLength", value: 2, label: "Menu Name" },
    { rule: "stringOnly", label: "Menu Name" },
  ],
  menu_slug: [
    { rule: "required", label: "Menu Slug" },
    { rule: "minLength", value: 2, label: "Menu Slug" },
    {
      rule: "regex",
      value: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
      label: "Menu Slug",
    },
  ],
};

export const CurrencyRules = {
  currencyname: [{ rule: "required", label: "Currency Name" }],
  curr_icon: [{ rule: "required", label: "Currency Symbol" }],
  country_name: [
    { rule: "optional", label: "Country Name" },
    { rule: "stringOnly", label: "Country Name" },
    { rule: "maxLength", value: 100, label: "Country Name" },
  ],
  position: [
    { rule: "required", label: "Position" },
    { rule: "enum", values: [0, 1, "0", "1"], label: "Position" },
  ],
  curr_rate: [
    { rule: "required", label: "Currency Rate" },
    { rule: "float", label: "Currency Rate" },
    { rule: "minNumber", value: 0, label: "Currency Rate" },
    { rule: "maxNumber", value: 99999, label: "Currency Rate" },
  ],
};

export const CommonSettingRules = {
  site_text: [{ rule: "minLength", value: 3, label: "Site Text" }],
  phone: [{ rule: "regex", value: /^[0-9]{6,15}$/, label: "Phone Number" }],
  email: [{ rule: "email", label: "Email" }],
  powerbytxt: [{ rule: "required", label: "Powered By Text" }],
  lenguage: [{ rule: "required", label: "Language" }],
  address: [{ rule: "minLength", value: 10, label: "Address" }],
  admin_logo: [
    {
      rule: "file",
      optional: true,
      types: ALLOWED_TYPES,
      maxSize: MAX_FILE_SIZE,
      label: "Admin Logo",
    },
  ],
  web_logo: [
    {
      rule: "file",
      optional: true,
      types: ALLOWED_TYPES,
      maxSize: MAX_FILE_SIZE,
      label: "Web Logo",
    },
  ],
  working_hours: [
    { rule: "required", label: "Working Hours" },
    { rule: "number", label: "Working Hours" },
    { rule: "min", value: 1, label: "Working Hours" },
    { rule: "max", value: 24, label: "Working Hours" },
  ],
  map_lat: [{ rule: "required", label: "Map Latitude" }],
  map_long: [{ rule: "required", label: "Map Longitude" }],
  map_zoom: [{ rule: "required", label: "Map Zoom Level" }],
};

export const AttendanceRules = {
  employee_id: [{ rule: "required", label: "Employee" }],
  attendance_date: [{ rule: "required", label: "Date" }],
  sign_in: [{ rule: "required", label: "Sign In Time" }],
  status: [{ rule: "required", label: "Status" }],
};

export const PhraseTranslationRules = {
  translation: [
    { rule: "required", label: "Translation" },
    { rule: "minLength", value: 2, label: "Translation" },
    { rule: "maxLength", value: 200, label: "Translation" },
  ],
};

export const LanguageRules = {
  language: [
    { rule: "required", label: "Language" },
    { rule: "minLength", value: 2, label: "Language" },
    { rule: "maxLength", value: 50, label: "Language" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Language" },
  ],
};

export const PhraseRules = {
  phrase: [
    { rule: "required", label: "Phrase" },
    { rule: "minLength", value: 2, label: "Phrase" },
    { rule: "maxLength", value: 50, label: "Phrase" },
  ],
};

export const MailSettingRules = {
  protocol: [
    { rule: "required", label: "Protocol" },
    { rule: "enum", values: ["SMTP", "POP3", "IMAP"], label: "Protocol" },
  ],
  mailpath: [
    { rule: "required", label: "Mail Path" },
    { rule: "minLength", value: 5, label: "Mail Path" },
    { rule: "maxLength", value: 50, label: "Mail Path" },
  ],
  mailtype: [
    { rule: "required", label: "Mail Type" },
    { rule: "enum", values: ["html", "text"], label: "Mail Type" },
  ],
  smtp_host: [
    { rule: "required", label: "SMTP Host" },
    { rule: "minLength", value: 5, label: "SMTP Host" },
    { rule: "maxLength", value: 50, label: "SMTP Host" },
  ],
  smtp_port: [
    { rule: "required", label: "SMTP Port" },
    { rule: "number", label: "SMTP Port" },
    { rule: "min", value: 1, label: "SMTP Port" },
    { rule: "max", value: 65535, label: "SMTP Port" },
  ],
  sender: [
    { rule: "required", label: "Sender Email" },
    { rule: "email", label: "Sender Email" },
  ],
  smtp_password: [
    { rule: "minLength", value: 8, label: "SMTP Password" },
    { rule: "maxLength", value: 20, label: "SMTP Password" },
  ],
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: ["0", "1"], label: "Status" },
  ],
};

export const EmailSettingRules = {
  booking: [{ rule: "enum", values: ["0", "1"], label: "Booking" }],
  checkin: [{ rule: "enum", values: ["0", "1"], label: "Checkin" }],
  checkout: [{ rule: "enum", values: ["0", "1"], label: "Checkout" }],
};

export const SmsSettingRules = {
  provider: [
    { rule: "required", label: "SMS Provider" },
    { rule: "string", label: "SMS Provider" },
    { rule: "minLength", value: 2, label: "SMS Provider" },
    { rule: "maxLength", value: 50, label: "SMS Provider" },
  ],
  api_key: [
    { rule: "optional", label: "API Key" },
    { rule: "string", label: "API Key" },
    { rule: "minLength", value: 10, label: "API Key" },
  ],
  sender_id: [
    { rule: "optional", label: "Sender ID" },
    { rule: "string", label: "Sender ID" },
    { rule: "minLength", value: 2, label: "Sender ID" },
    { rule: "maxLength", value: 50, label: "Sender ID" },
  ],
  base_url: [
    { rule: "optional", label: "Base URL" },
    { rule: "url", label: "Base URL" },
  ],
  sms_type: [
    { rule: "optional", label: "SMS Type" },
    {
      rule: "enum",
      values: ["transactional", "promotional"],
      label: "SMS Type",
    },
  ],
  status: [
    { rule: "optional", label: "Status" },
    { rule: "enum", values: ["0", "1", "active", "inactive"], label: "Status" },
  ],
  unicode: [
    { rule: "enum", values: ["0", "1", true, false], label: "Unicode Support" },
  ],
};

export const RoomFacilityTypeRules = {
  facilitytypetitle: [
    { rule: "required", label: "Facility Type Title" },
    { rule: "string", label: "Facility Type Title" },
    { rule: "minLength", value: 2, label: "Facility Type Title" },
    { rule: "maxLength", value: 100, label: "Facility Type Title" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Facility Type Title" },
  ],
};

export const RoomFacilityDetailRules = {
  image: [{ rule: "required", label: "Facility Detail Icon" }],
  facilitytypeid: [{ rule: "required", label: "Facility Type" }],
  facilitytitle: [
    { rule: "required", label: "Facility Title" },
    { rule: "string", label: "Facility Title" },
    { rule: "minLength", value: 2, label: "Facility Title" },
    { rule: "maxLength", value: 100, label: "Facility Title" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Facility Title" },
  ],
};

export const RoomSizeRules = {
  roommesurementitle: [
    { rule: "required", label: "Room Size" },
    { rule: "minLength", value: 2, label: "Room Size" },
    { rule: "maxLength", value: 100, label: "Room Size" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Room Size" },
  ],
};

export const BookingTypeRules = {
  booking_type_name: [
    { rule: "required", label: "Booking type" },
    { rule: "minLength", value: 2, label: "Booking type" },
    { rule: "maxLength", value: 100, label: "Booking type" },
    { rule: "regex", value: /^[A-Za-z0-9\s]+$/, label: "Booking type" },
    { rule: "stringOnly", label: "Booking type" },
  ],
};

export const BedListRules = {
  beds_typetitle: [
    { rule: "required", label: "Bed Type" },
    { rule: "minLength", value: 2, label: "Bed Type" },
    { rule: "maxLength", value: 100, label: "Bed Type" },
    { rule: "stringOnly", label: "Bed Type" },
  ],
};

export const BookingCommissionRules = {
  booking_type: [
    { rule: "required", label: "Booking Type" },
    { rule: "numeric", label: "Booking Type" },
  ],
  booking_source_name: [
    { rule: "required", label: "Booking Source Name" },
    { rule: "minLength", value: 2, label: "Booking Source Name" },
    { rule: "maxLength", value: 100, label: "Booking Source Name" },
  ],
  commission_rate: [
    { rule: "required", label: "Commission Rate" },
    { rule: "numeric", label: "Commission Rate" },
    { rule: "minNumber", value: 0, label: "Commission Rate" },
    { rule: "maxNumber", value: 100, label: "Commission Rate" },
  ],
};

export const RoomRules = {
  room_type: [
    { rule: "required", label: "Room Type" },
    { rule: "string", label: "Room Type" },
  ],
  room_size: [
    { rule: "required", label: "Room Size" },
    { rule: "numeric", label: "Room Size" },
  ],
  room_size_mesurement: [
    { rule: "required", label: "Room Size Mesurement" },
    { rule: "numeric", label: "Room Size Mesurement" },
  ],
  beds_no: [
    { rule: "required", label: "Beds Number" },
    { rule: "numeric", label: "Beds Number" },
  ],
  beds_type: [
    { rule: "required", label: "Beds Type" },
    { rule: "numeric", label: "Beds Type" },
  ],
  number_of_star: [
    { rule: "required", label: "Number of Star" },
    { rule: "numeric", label: "Number of Star" },
  ],
  reserve_condition: [
    { rule: "minLength", value: 2, label: "Reserve Condition" },
    { rule: "maxLength", value: 255, label: "Reserve Condition" },
  ],
  room_description: [
    { rule: "minLength", value: 2, label: "Room Description" },
    { rule: "maxLength", value: 255, label: "Room Description" },
  ],
  capacity: [
    { rule: "required", label: "Capacity" },
    { rule: "numeric", label: "Capacity" },
  ],
  exbed_capability: [
    { rule: "enum", values: [0, 1], label: "Extra Bed Capability" },
  ],
  exbed_capability_limit: [{ rule: "numeric", label: "Extra Bed Limit" }],
  rate: [
    { rule: "required", label: "Rate" },
    { rule: "numeric", label: "Rate" },
  ],
  bed_charge: [
    { rule: "required", label: "Bed Charge" },
    { rule: "numeric", label: "Bed Charge" },
  ],
  person_charge: [
    { rule: "required", label: "Person Charge" },
    { rule: "numeric", label: "Person Charge" },
  ],
};

export const RoomImagesRules = {
  room_id: [
    { rule: "required", label: "Room ID" },
    { rule: "numeric", label: "Room ID" },
  ],
};

export const HallImagesRules = {
  hall_room_id: [
    { rule: "required", label: "Hall Room ID" },
    { rule: "numeric", label: "Hall Room ID" },
  ],
};

export const ItemsUnitRules = {
  uom_name: [
    { rule: "required", label: "Unit Name" },
    { rule: "stringOnly", label: "Unit Name" },
    { rule: "minLength", value: 2, label: "Unit Name" },
    { rule: "maxLength", value: 100, label: "Unit Name" },
  ],

  uom_short_code: [
    { rule: "required", label: "Unit Short Code" },
    { rule: "minLength", value: 1, label: "Unit Short Code" },
    { rule: "maxLength", value: 10, label: "Unit Short Code" },
    {
      rule: "regex",
      value: /^[A-Za-z0-9/.\-°%²³ ]+$/,
      label: "Unit Short Code",
      message:
        "Short code may only contain letters, digits, and symbols: / . - ° % ² ³ (e.g. kg, m², fl.oz, °C, km/h)",
    },
  ],

  // 0 = Inactive, 1 = Active
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: [0, 1, "0", "1"], label: "Status" },
  ],
};

export const ProductCategoryRules = {
  // Category name — letters and spaces only.
  // Valid:   "Beverages", "Cleaning Supplies", "Dry Goods"
  // Invalid: "111", "Category1", "@Items"
  categoryname: [
    { rule: "required", label: "Category Name" },
    { rule: "stringOnly", label: "Category Name" },
    { rule: "minLength", value: 2, label: "Category Name" },
    { rule: "maxLength", value: 100, label: "Category Name" },
  ],
  // 0 = Inactive, 1 = Active
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: [0, 1, "0", "1"], label: "Status" },
  ],
};

export const ProductsListRules = {
  // Product name — must contain letters. Allows digits and common punctuation.
  // Valid:   "Soap Bar", "Cleaning Fluid 500ml", "Bed Sheet (King)"
  // Invalid: "111", "@Product!", "###"
  product_name: [
    { rule: "required", label: "Product Name" },
    { rule: "minLength", value: 2, label: "Product Name" },
    { rule: "maxLength", value: 255, label: "Product Name" },
    {
      rule: "regex",
      value: /^(?=.*[A-Za-z])[A-Za-z0-9\s.,\-'()]+$/,
      label: "Product Name",
      message:
        "Product name must contain letters and may include digits, spaces, and . , - ' ( )",
    },
  ],
  // FK → tbl_category
  category_id: [
    { rule: "required", label: "Category" },
    { rule: "numeric", label: "Category" },
  ],
  // FK → unit_of_measurement
  uom_id: [
    { rule: "required", label: "Unit of Measurement" },
    { rule: "numeric", label: "Unit of Measurement" },
  ],
  // Stock — positive integer, minimum 1
  stock: [
    { rule: "required", label: "Stock Quantity" },
    { rule: "numeric", label: "Stock Quantity" },
    { rule: "minValue", value: 1, label: "Stock Quantity" },
  ],
  // status is enum('0','1') in products_list — string values only
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: ["0", "1"], label: "Status" },
  ],
};

/**
 * ProductsEditRules — used on the Edit Product form.
 * Excludes `stock` — stock is managed by purchase/destruction modules,
 * not editable via the product edit form.
 * available_quantity and stock_quantity are read-only display fields — not validated.
 */
export const ProductsEditRules = {
  product_name: [
    { rule: "required", label: "Product Name" },
    { rule: "minLength", value: 2, label: "Product Name" },
    { rule: "maxLength", value: 255, label: "Product Name" },
    {
      rule: "regex",
      value: /^(?=.*[A-Za-z])[A-Za-z0-9\s.,\-'()]+$/,
      label: "Product Name",
      message:
        "Product name must contain letters and may include digits, spaces, and . , - ' ( )",
    },
  ],
  category_id: [
    { rule: "required", label: "Category" },
    { rule: "numeric", label: "Category" },
  ],
  uom_id: [
    { rule: "required", label: "Unit of Measurement" },
    { rule: "numeric", label: "Unit of Measurement" },
  ],
  // status is enum('0','1') in products_list
  status: [
    { rule: "required", label: "Status" },
    { rule: "numeric", label: "Status" },
    { rule: "inum", values: [0, 1], label: "Status" },
    { rule: "enum", values: ["0", "1"], label: "Status" },
  ],
  // stock_quantity — editable total; available adjusts by delta
  stock_quantity: [
    { rule: "required", label: "Total Stock Quantity" },
    { rule: "numeric", label: "Total Stock Quantity" },
    { rule: "minValue", value: 0, label: "Total Stock Quantity" },
  ],
};

export const SupplierValidationRules = {
  // Business name — must contain letters. Allows spaces and common punctuation.
  // Valid:   "ABC & Co.", "Smith's Ltd.", "O'Brien Supplies"
  // Invalid: "111", "123", "@Supplier!", "###"
  supplier_name: [
    { rule: "required", label: "Supplier Name" },
    { rule: "minLength", value: 3, label: "Supplier Name" },
    { rule: "maxLength", value: 100, label: "Supplier Name" },
    {
      rule: "regex",
      value: /^(?=.*[A-Za-z])[A-Za-z\s.,\-'&()]+$/,
      label: "Supplier Name",
      message:
        "Supplier name must contain letters and may include . , - ' & ( )",
    },
  ],
  supplier_email: [
    { rule: "required", label: "Supplier Email" },
    { rule: "email", label: "Supplier Email" },
  ],
  supplier_mobile: [
    { rule: "required", label: "Supplier Mobile" },
    { rule: "numeric", label: "Supplier Mobile" },
    {
      rule: "regex",
      value: /^[0-9]{10,15}$/,
      label: "Supplier Mobile",
      message: "Mobile must be 10 to 15 digits",
    },
  ],
  supplier_address: [
    { rule: "optional", label: "Supplier Address" },
    { rule: "minLength", value: 5, label: "Supplier Address" },
    { rule: "maxLength", value: 255, label: "Supplier Address" },
  ],
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: [0, 1, "0", "1"], label: "Status" },
  ],
};

export const ComplementaryRules = {
  room_type: [
    { rule: "required", label: "Room Type Name" },
    { rule: "numeric", label: "Room Type Name" },
  ],
  complementary_name: [
    { rule: "required", label: "Complementary Name" },
    { rule: "stringOnly", label: "Complementary Name" },
    { rule: "minLength", value: 2, label: "Complementary Name" },
    { rule: "maxLength", value: 100, label: "Complementary Name" },
  ],
  rate: [
    { rule: "required", label: "Rate" },
    { rule: "float", label: "Rate" },
    { rule: "regex", value: /^\d+(\.\d{1,2})?$/, label: "Rate" },
  ],
};

export const FloorRules = {
  floor_name: [
    { rule: "required", label: "Floor Name" },
    { rule: "stringOnly", label: "Floor Name" },
    { rule: "minLength", value: 2, label: "Floor Name" },
    { rule: "maxLength", value: 255, label: "Floor Name" },
  ],
};

export const DestroyedItemsRules = {
  // FK → products_list — must be a selected product ID
  product_id: [
    { rule: "required", label: "Product Name" },
    { rule: "numeric", label: "Product Name" },
  ],
  // Quantity destroyed — positive integer, minimum 1
  quantity: [
    { rule: "required", label: "Quantity" },
    { rule: "numeric", label: "Quantity" },
    { rule: "minValue", value: 1, label: "Quantity" },
  ],
  // Comment — optional but meaningful if provided
  comment: [
    { rule: "optional", label: "Comment" },
    { rule: "minLength", value: 2, label: "Comment" },
    { rule: "maxLength", value: 255, label: "Comment" },
  ],
};

export const FloorAssignRules = {
  floor_name: [
    { rule: "required", label: "Floor Name" },
    { rule: "numeric", label: "Floor Name" },
  ],

  no_of_room: [
    { rule: "required", label: "Number of Rooms" },
    { rule: "numeric", label: "Number of Rooms" },
    { rule: "minValue", value: 1, label: "Number of Rooms" },
  ],

  start_no: [
    { rule: "required", label: "Starting Room Number" },
    { rule: "numeric", label: "Starting Room Number" },
    { rule: "minValue", value: 1, label: "Starting Room Number" },
  ],

  room_no: [
    { rule: "array", label: "Room Numbers" },
    { rule: "minLength", value: 1, label: "Room Numbers" },
  ],
};

export const TaxManagementRules = {
  tax_name: [
    { rule: "required", label: "Name" },
    { rule: "minLength", value: 2, label: "Name" },
    { rule: "maxLength", value: 100, label: "Name" },
    { rule: "stringOnly", label: "Name" },
  ],
  reg_no: [
    { rule: "required", label: "Registration Number" },
    { rule: "minLength", value: 2, label: "Registration Number" },
    { rule: "maxLength", value: 255, label: "Registration Number" },
    { rule: "regex", value: /^[a-zA-Z0-9\s]+$/, label: "Registration Number" },
    { rule: "maxLength", value: 100, label: "Name" },
  ],
  rate: [
    { rule: "required", label: "Rate" },
    { rule: "float", label: "Rate" },
    { rule: "regex", value: /^\d+(\.\d{1,2})?$/, label: "Rate" },
  ],
};

export const AssignRoomTypeToRoom = {
  room_type: [
    { rule: "required", label: "Room Type" },
    { rule: "numeric", label: "Room Type" },
  ],

  room_no: [{ rule: "array", label: "Room Numbers" }],
};

export const PromoCodeRules = {
  room_id: [
    { rule: "required", label: "Room" },
    { rule: "numeric", label: "Room" },
  ],
  promo_code: [
    { rule: "required", label: "Promo Code" },
    { rule: "minLength", value: 2, label: "Promo Code" },
    { rule: "maxLength", value: 50, label: "Promo Code" },
    { rule: "regex", value: /^[A-Za-z0-9_-]+$/, label: "Promo Code" },
  ],
  discount: [
    { rule: "required", label: "Discount" },
    { rule: "float", label: "Discount" },
    { rule: "minNumber", value: 0, label: "Discount" },
    { rule: "maxNumber", value: 100, label: "Discount" },
  ],
  max_limit: [
    { rule: "required", label: "Max Limit" },
    { rule: "numeric", label: "Max Limit" },
    { rule: "minNumber", value: 1, label: "Max Limit" },
  ],
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: [0, 1], label: "Status" },
  ],
};

export const CustomersRules = {
  first_name: [
    { rule: "required", label: "First Name" },
    { rule: "string", label: "First Name" },
    { rule: "minLength", value: 2, label: "First Name" },
    { rule: "maxLength", value: 100, label: "First Name" },
    { rule: "regex", value: /^[A-Za-z]+$/, label: "First Name" },
  ],
  last_name: [
    { rule: "required", label: "Last Name" },
    { rule: "string", label: "Last Name" },
    { rule: "minLength", value: 2, label: "Last Name" },
    { rule: "maxLength", value: 100, label: "Last Name" },
    { rule: "regex", value: /^[A-Za-z]+$/, label: "Last Name" },
  ],
  father_name: [
    { rule: "required", label: "Father Name" },
    { rule: "string", label: "Father Name" },
    { rule: "minLength", value: 2, label: "Father Name" },
    { rule: "maxLength", value: 100, label: "Father Name" },
    { rule: "regex", value: /^[A-Za-z]+$/, label: "Father Name" },
  ],
  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
  ],
  customer_phone: [
    { rule: "required", label: "Customer Phone" },
    { rule: "numeric", label: "Customer Phone" },
    { rule: "minLength", value: 10, label: "Customer Phone" },
    { rule: "maxLength", value: 15, label: "Customer Phone" },
    { rule: "regex", value: /^[0-9]+$/, label: "Customer Phone" },
  ],
  gender: [
    { rule: "string", label: "Gender" },
    { rule: "enum", values: ["Male", "Female", "Other"], label: "Gender" },
  ],
  profession: [
    { rule: "required", label: "Profession" },
    { rule: "string", label: "Profession" },
    { rule: "minLength", value: 2, label: "Profession" },
    { rule: "maxLength", value: 100, label: "Profession" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Profession" },
  ],
  status: [
    { rule: "required", label: "Status" },
    {
      rule: "enum",
      values: ["active", "inactive", "suspended"],
      label: "Status",
    },
  ],
  is_nationality: [
    { rule: "required", label: "Nationality" },
    { rule: "enum", values: ["national", "foreigner"], label: "Nationality" },
  ],
  city: [
    { rule: "optional", label: "City" },
    { rule: "string", label: "City" },
    { rule: "minLength", value: 2, label: "City" },
    { rule: "maxLength", value: 100, label: "City" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "City" },
  ],
  zip_code: [
    { rule: "optional", label: "Zip Code" },
    { rule: "minLength", value: 2, label: "Zip Code" },
    { rule: "maxLength", value: 100, label: "Zip Code" },
    { rule: "regex", value: /^[0-9]+$/, label: "Zip Code" },
  ],
  pid: [
    { rule: "optional", label: "person id" },
    { rule: "minLength", value: 2, label: "PID" },
    { rule: "maxLength", value: 100, label: "PID" },
    { rule: "regex", value: /^[A-Za-z0-9]+$/, label: "PID" },
  ],
  address: [
    { rule: "optional", label: "Address" },
    { rule: "string", label: "Address" },
    { rule: "minLength", value: 2, label: "Address" },
    { rule: "maxLength", value: 255, label: "Address" },
  ],

  nationality: [
    { rule: "optional", label: "Nationality" },
    { rule: "string", label: "Nationality" },
    { rule: "minLength", value: 2, label: "Nationality" },
    { rule: "maxLength", value: 100, label: "Nationality" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Nationality" },
  ],
  passport: [
    { rule: "optional", label: "Passport" },
    { rule: "string", label: "Passport" },
    { rule: "minLength", value: 2, label: "Passport" },
    { rule: "maxLength", value: 100, label: "Passport" },
    { rule: "regex", value: /^[A-Za-z0-9]+$/, label: "Passport" },
  ],
  visa_no: [
    { rule: "optional", label: "Visa Number" },
    { rule: "string", label: "Visa Number" },
    { rule: "minLength", value: 2, label: "Visa Number" },
    { rule: "maxLength", value: 100, label: "Visa Number" },
    { rule: "regex", value: /^[A-Za-z0-9]+$/, label: "Visa Number" },
  ],
  purpose: [
    { rule: "optional", label: "Purpose" },
    { rule: "string", label: "Purpose" },
    { rule: "minLength", value: 2, label: "Purpose" },
    { rule: "maxLength", value: 100, label: "Purpose" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Purpose" },
  ],
};

export const AssignRoomFacilitiesValidation = {
  room_no: [{ rule: "array", label: "Room Numbers" }],
  facilities: [{ rule: "array", label: "Facilities" }],
};

export const AssignRoomOfferValidation = {
  room_id: [{ rule: "required", label: "Room Numbers" }],
  offer_date: [{ rule: "required", label: "Offer Date" }],
  offer: [
    { rule: "required", label: "Offer Price" },
    { rule: "numeric", label: "Offer Price" },
    { rule: "minValue", value: 0, label: "Offer Price" },
    { rule: "rgex", value: /^\d+(\.\d{1,2})?$/, label: "Offer Price" },
  ],
  offer_title: [
    { rule: "required", label: "Offer Title" },
    { rule: "string", label: "Offer Title" },
    { rule: "minLength", value: 2, label: "Offer Title" },
    { rule: "maxLength", value: 100, label: "Offer Title" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Offer Title" },
  ],
  offer_text: [
    { rule: "required", label: "Offer Text" },
    { rule: "string", label: "Offer Text" },
    { rule: "minLength", value: 2, label: "Offer Text" },
    { rule: "maxLength", value: 255, label: "Offer Text" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Offer Text" },
  ],
};

export const WakeUpCallValidation = {
  customer_id: [
    { rule: "required", label: "Customer" },
    { rule: "numeric", label: "Customer" },
  ],
  wk_time: [{ rule: "required", label: "Wake-up Time" }],
  remarks: [
    { rule: "minLength", value: 2, label: "Remarks" },
    { rule: "maxLength", value: 255, label: "Remarks" },
  ],
};

export const GuestValidation = {
  guest_name: [
    { rule: "required", label: "Guest Name" },
    { rule: "string", label: "Guest Name" },
    { rule: "minLength", value: 2, label: "Guest Name" },
    { rule: "maxLength", value: 150, label: "Guest Name" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Guest Name" },
  ],

  mobile: [
    { rule: "optional", label: "Mobile" },
    { rule: "mobile", label: "Mobile" },
    { rule: "minLength", value: 10, label: "Mobile" },
    { rule: "maxLength", value: 15, label: "Mobile" },
  ],
  email: [
    { rule: "optional", label: "Email" },
    { rule: "email", label: "Email" },
  ],
};

export const PaymentCurrencyRules = {
  currency_name: [
    { rule: "required", label: "Currency Name" },
    { rule: "string", label: "Currency Name" },
    { rule: "minLength", value: 2, label: "Currency Name" },
    { rule: "maxLength", value: 100, label: "Currency Name" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Currency Name" },
  ],
  currency_detail: [
    { rule: "optional", label: "Currency Detail" },
    { rule: "string", label: "Currency Detail" },
    { rule: "minLength", value: 2, label: "Currency Detail" },
    { rule: "maxLength", value: 255, label: "Currency Detail" },
  ],
  status: [
    { rule: "required", label: "Status" },
    { rule: "in", value: ["1", "0"], label: "Status" },
  ],
};

export const paymentMethodValidationRules = {
  payment_method_name: [
    { rule: "required", label: "Payment Method Name" },
    { rule: "string", label: "Payment Method Name" },
    { rule: "minLength", value: 2, label: "Payment Method Name" },
    { rule: "maxLength", value: 100, label: "Payment Method Name" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "Payment Method Name" },
  ],
  status: [
    { rule: "required", label: "Status" },
    { rule: "in", value: ["1", "0"], label: "Status" },
  ],
};

export const PaymentSetupValidationRules = {
  payment_method_id: [
    { rule: "required", label: "Payment Method" },
    { rule: "regex", value: /^[A-Za-z0-9]+$/, label: "Payment Method" },
  ],
  merchant_id: [
    { rule: "required", label: "Merchant ID" },
    { rule: "minLength", value: 2, label: "Merchant ID" },
    { rule: "maxLength", value: 100, label: "Merchant ID" },
    { rule: "regex", value: /^[A-Za-z0-9]+$/, label: "Merchant ID" },
  ],

  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
  ],
  currency_id: [
    { rule: "required", label: "Currency" },
    { rule: "number", label: "Currency" },
  ],
  status: [
    { rule: "required", label: "Status" },
    { rule: "in", value: ["1", "0"], label: "Status" },
  ],
};

export const PurchaseItemRules = {
  invoice_id: [
    { rule: "required", label: "Invoice ID" },
    { rule: "string", label: "Invoice ID" },
    { rule: "maxLength", value: 50, label: "Invoice ID" },
    { rule: "regex", value: /^(INV|GEGX)-\d{8}-\d{3,}$/, label: "Invoice ID" },
  ],

  supplier_id: [
    { rule: "required", label: "Supplier" },
    { rule: "number", label: "Supplier" },
  ],

  details: [
    { rule: "optional", label: "Details" },
    { rule: "string", label: "Details" },
    { rule: "maxLength", value: 255, label: "Details" },
  ],

  purchase_date: [
    { rule: "required", label: "Purchase Date" },
    { rule: "date", label: "Purchase Date" },
  ],

  purchase_expiry_date: [
    { rule: "required", label: "Purchase Expiry Date" },
    { rule: "date", label: "Purchase Expiry Date" },
  ],
};

export const PurchaseReturnRules = {
  supplier_id: [
    { rule: "required", label: "Supplier" },
    { rule: "number", label: "Supplier" },
  ],
  purchase_invoice_id: [
    { rule: "required", label: "Purchase Invoice" },
    { rule: "number", label: "Purchase Invoice" },
  ],
};

export const bookingTimeCustomerRules = {
  // --- User Details ---
  customer_phone: [
    { rule: "required", label: "Mobile Number" },
    { rule: "minLength", value: 10, label: "Mobile Number" },
    { rule: "maxLength", value: 15, label: "Mobile Number" },
    { rule: "regex", value: /^[0-9]+$/, label: "Mobile Number" },
  ],
  title: [{ rule: "required", label: "Title" }],
  first_name: [
    { rule: "required", label: "First Name" },
    { rule: "minLength", value: 2, label: "First Name" },
    { rule: "maxLength", value: 100, label: "First Name" },
    { rule: "regex", value: /^[A-Za-z\s]+$/, label: "First Name" },
  ],
  gender: [
    { rule: "required", label: "Gender" },
    { rule: "enum", values: ["Male", "Female", "Other"], label: "Gender" },
  ],
  nationality: [
    { rule: "required", label: "Nationality" },
    { rule: "minLength", value: 2, label: "Nationality" },
    { rule: "maxLength", value: 100, label: "Nationality" },
  ],
  // --- Contact Details ---
  contact_type: [{ rule: "required", label: "Contact Type" }],
  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
  ],
  country: [{ rule: "required", label: "Country" }],
  city: [
    { rule: "required", label: "City" },
    { rule: "minLength", value: 2, label: "City" },
    { rule: "maxLength", value: 100, label: "City" },
  ],
  zip_code: [
    { rule: "required", label: "Zip Code" },
    { rule: "minLength", value: 2, label: "Zip Code" },
    { rule: "maxLength", value: 20, label: "Zip Code" },
  ],
  address: [
    { rule: "required", label: "Address" },
    { rule: "minLength", value: 2, label: "Address" },
    { rule: "maxLength", value: 255, label: "Address" },
  ],
  // --- Identity Details ---
  pid_type: [
    { rule: "required", label: "Identity Type" },
    { rule: "minLength", value: 2, label: "Identity Type" },
    { rule: "maxLength", value: 100, label: "Identity Type" },
  ],
  pid: [
    { rule: "required", label: "Identity ID" },
    { rule: "minLength", value: 2, label: "Identity ID" },
    { rule: "maxLength", value: 100, label: "Identity ID" },
    { rule: "regex", value: /^[A-Za-z0-9]+$/, label: "Identity ID" },
  ],
};

export const RoomCheckOutRules = {
  booking_id: [
    { rule: "required", label: "Booking" },
    { rule: "number", label: "Booking" },
  ],
};

export const PoolTypeRules = {
  pool_type_name: [
    { rule: "required", label: "Pool Type Name" },
    { rule: "stringOnly", label: "Pool Type Name" },
    { rule: "minLength", value: 2, label: "Pool Type Name" },
    { rule: "maxLength", value: 255, label: "Pool Type Name" },
  ],
};

export const SwimmingPoolRules = {
  s_pool_name: [
    { rule: "required", label: "Pool Name" },
    { rule: "stringOnly", label: "Pool Name" },
    { rule: "minLength", value: 2, label: "Pool Name" },
    { rule: "maxLength", value: 255, label: "Pool Name" },
  ],
  pool_type: [
    { rule: "required", label: "Pool Type" },
    { rule: "number", label: "Pool Type" },
  ],
  capacity: [
    { rule: "required", label: "Capacity" },
    { rule: "numeric", label: "Capacity" },
  ],
  status: [
    { rule: "required", label: "Status" },
    { rule: "in", value: [1, 2, 3, 4, "1", "2", "3", "4"], label: "Status" },
  ],
  remarks: [
    { rule: "optional", label: "Remarks" },
    { rule: "string", label: "Remarks" },
    { rule: "maxLength", value: 255, label: "Remarks" },
  ],
};

export const PoolBookingRules = {
  p_pack_id: [{ rule: "required", label: "Package Name" }],
  customer_id: [{ rule: "optional", label: "Customer Name" }],
  price: [
    { rule: "required", label: "Price" },
    { rule: "numeric", label: "Price" },
    { rule: "minValue", value: 1, label: "Price" },
  ],
  units: [
    { rule: "required", label: "Units" },
    { rule: "numeric", label: "Units" },
    { rule: "minValue", value: 1, label: "Units" },
  ],
};

export const PoolPackageCustomerRules = {
  first_name: [
    { rule: "required", label: "First Name" },
    { rule: "stringOnly", label: "First Name" },
    { rule: "minLength", value: 2, label: "First Name" },
    { rule: "maxLength", value: 255, label: "First Name" },
  ],
  last_name: [
    { rule: "required", label: "Last Name" },
    { rule: "stringOnly", label: "Last Name" },
    { rule: "minLength", value: 2, label: "Last Name" },
    { rule: "maxLength", value: 255, label: "Last Name" },
  ],
  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
  ],
  customer_number: [
    { rule: "required", label: "Customer Phone" },
    { rule: "numeric", label: "Customer Phone" },
    { rule: "minLength", value: 10, label: "Customer Phone" },
    { rule: "maxLength", value: 15, label: "Customer Phone" },
  ],
  pid_type: [{ rule: "required", label: "Package Type" }],
  pid: [{ rule: "required", label: "Package ID" }],
};

export const ZoneTypeRules = {
  zone_type: [
    { rule: "required", label: "Zone Type Name" },
    { rule: "stringOnly", label: "Zone Type Name" },
    { rule: "minLength", value: 2, label: "Zone Type Name" },
    { rule: "maxLength", value: 255, label: "Zone Type Name" },
  ],
};

export const VehicleListRules = {
  vehicle_type: [
    { rule: "required", label: "Vehicle Type" },
    { rule: "stringOnly", label: "Vehicle Type" },
    { rule: "minLength", value: 2, label: "Vehicle Type" },
    { rule: "maxLength", value: 255, label: "Vehicle Type" },
  ],
};

export const SlotRules = {
  zone_list_id: [
    { rule: "required", label: "Zone Type" },
    { rule: "number", label: "Zone Type" },
  ],
  slot_type: [
    { rule: "required", label: "Slot Type" },
    { rule: "stringOnly", label: "Slot Type" },
    { rule: "minLength", value: 2, label: "Slot Type" },
    { rule: "maxLength", value: 255, label: "Slot Type" },
  ],
};

export const ParkingSettingRules = {
  zone_list_id: [
    { rule: "required", label: "Zone Type" },
    { rule: "number", label: "Zone Type" },
  ],
  vehicle_list_id: [
    { rule: "required", label: "Vehicle Type" },
    { rule: "number", label: "Vehicle Type" },
  ],
  hours: [
    { rule: "required", label: "Hours" },
    { rule: "number", label: "Hours" },
  ],
  price: [
    { rule: "required", label: "Price" },
    { rule: "number", label: "Price" },
  ],
  tax_id: [
    { rule: "required", label: "Tax" },
    { rule: "number", label: "Tax" },
  ],
};

export const ParkingBookingRules = {
  booking_number: [
    { rule: "required", label: "Booking Number" },
    { rule: "number", label: "Booking Number" },
  ],
  vehicle_list_id: [
    { rule: "required", label: "Vehicle Type" },
    { rule: "number", label: "Vehicle Type" },
  ],
  zone_list_id: [
    { rule: "required", label: "Zone Type" },
    { rule: "number", label: "Zone Type" },
  ],
  setting_id: [
    { rule: "required", label: "Time" },
    { rule: "number", label: "Time" },
  ],
  checkin_date: [{ rule: "required", label: "Check In Date" }],
  checkout_date: [{ rule: "required", label: "Check Out Date" }],
  slot_list_id: [
    { rule: "required", label: "Slot" },
    { rule: "number", label: "Slot" },
  ],
};

export const HallSeatPlanRules = {
  image: [{ rule: "required", label: "Image" }],
  plan_name: [
    { rule: "required", label: "Plan Name" },
    { rule: "minLength", value: 2, label: "Plan Name" },
    { rule: "maxLength", value: 255, label: "Plan Name" },
    { rule: "stringOnly", label: "Plan Name" },
  ],
  description: [
    { rule: "required", label: "Description" },
    { rule: "minLength", value: 2, label: "Description" },
    { rule: "maxLength", value: 255, label: "Description" },
  ],
};

export const HallTypeRules = {
  image: [{ rule: "required", label: "Image" }],
  hallroom_type: [
    { rule: "required", label: "Hall Type" },
    { rule: "minLength", value: 2, label: "Hall Type" },
    { rule: "maxLength", value: 255, label: "Hall Type" },
    { rule: "stringOnly", label: "Hall Type" },
  ],
  capacity: [
    { rule: "required", label: "Capacity" },
    { rule: "number", label: "Capacity" },
  ],
  hourly_rate: [
    { rule: "required", label: "Hourly Rate" },
    { rule: "number", label: "Hourly Rate" },
  ],
  seatplan_id: [
    { rule: "required", label: "Seat Plan" },
    { rule: "number", label: "Seat Plan" },
  ],
};

export const fooditemRules = {
  image: [
    { rule: "required", label: "Image" },
    {
      rule: "fileType",
      value: ["jpg", "jpeg", "png", "gif", "webp"],
      label: "Image",
    },
    { rule: "maxFileSize", value: 5, label: "Image" }, // 5MB max
  ],
  food_name: [
    { rule: "required", label: "Food Name" },
    { rule: "stringOnly", label: "Food Name" },
    { rule: "minLength", value: 2, label: "Food Name" },
    { rule: "maxLength", value: 255, label: "Food Name" },
    { rule: "noSpecialChars", label: "Food Name" },
    { rule: "noNumbersOnly", label: "Food Name" },
  ],
  food_type_id: [
    { rule: "required", label: "Food Type" },
    { rule: "number", label: "Food Type" },
    { rule: "min", value: 1, label: "Food Type" },
  ],
  description: [
    { rule: "required", label: "Description" },
    { rule: "stringOnly", label: "Description" },
    { rule: "minLength", value: 10, label: "Description" },
    { rule: "maxLength", value: 1000, label: "Description" },
    { rule: "noHtmlTags", label: "Description" },
  ],
};

export const FoodPackageRules = {
  package_name: [
    { rule: "required", label: "Package Name" },
    { rule: "stringOnly", label: "Package Name" },
    { rule: "minLength", value: 2, label: "Package Name" },
    { rule: "maxLength", value: 255, label: "Package Name" },
    { rule: "noSpecialChars", label: "Package Name" },
    { rule: "noNumbersOnly", label: "Package Name" },
  ],
  package_price: [
    { rule: "required", label: "Package Price" },
    { rule: "number", label: "Package Price" },
    { rule: "min", value: 0, label: "Package Price" },
    { rule: "max", value: 999999, label: "Package Price" },
  ],
  description: [
    { rule: "required", label: "Description" },
    { rule: "stringOnly", label: "Description" },
    { rule: "minLength", value: 10, label: "Description" },
    { rule: "maxLength", value: 1000, label: "Description" },
    { rule: "noHtmlTags", label: "Description" },
  ],
};

export const PackageFoodTypeRules = {
  package_id: [
    { rule: "required", label: "Package" },
    { rule: "number", label: "Package" },
  ],
  food_type_id: [
    { rule: "required", label: "Food Type" },
    { rule: "number", label: "Food Type" },
  ],
  allowed_quantity: [
    { rule: "required", label: "Allowed Quantity" },
    { rule: "number", label: "Allowed Quantity" },
  ],
};

export const PackageFoodTypeLimitRules = {
  package_id: [
    { rule: "required", label: "Package" },
    { rule: "number", label: "Package" },
    { rule: "min", value: 1, label: "Package" },
  ],
  food_type_id: [
    { rule: "required", label: "Food Type" },
    { rule: "number", label: "Food Type" },
    { rule: "min", value: 1, label: "Food Type" },
  ],
  allowed_quantity: [
    { rule: "required", label: "Allowed Quantity" },
    { rule: "number", label: "Allowed Quantity" },
    { rule: "min", value: 1, label: "Allowed Quantity" },
    { rule: "max", value: 999999, label: "Allowed Quantity" },
  ],
};

export const LaundryProductRules = {
  // product_name — selected from products_list dropdown (string value)
  product_name: [
    { rule: "required", label: "Product Name" },
    { rule: "minLength", value: 2, label: "Product Name" },
    { rule: "maxLength", value: 100, label: "Product Name" },
  ],
  // Category type — must match the defined dropdown options
  category_type: [
    { rule: "required", label: "Category Type" },
    {
      rule: "enum",
      values: ["housekeeping", "laundry", "inventory"],
      label: "Category Type",
    },
  ],
  // in_laundry_quantity — non-negative integer (0 is valid: nothing in laundry yet)
  in_laundry_quantity: [
    { rule: "required", label: "Laundry Quantity" },
    { rule: "numeric", label: "Laundry Quantity" },
    { rule: "minValue", value: 0, label: "Laundry Quantity" },
  ],
  // ready_quantity — must be at least 1 (product must have some ready stock)
  ready_quantity: [
    { rule: "required", label: "Ready Quantity" },
    { rule: "numeric", label: "Ready Quantity" },
    { rule: "minValue", value: 1, label: "Ready Quantity" },
  ],
  // 0 = Inactive, 1 = Active
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: ["0", "1"], label: "Status" },
  ],
};

/**
 * LaundryProductEditRules — used on the Edit Laundry Product form.
 * ready_quantity can be 0 on edit (all units may be in laundry).
 * total_quantity is fixed (original budget) — not validated from user input.
 */
export const LaundryProductEditRules = {
  product_name: [
    { rule: "required", label: "Product Name" },
    { rule: "minLength", value: 2, label: "Product Name" },
    { rule: "maxLength", value: 100, label: "Product Name" },
  ],
  category_type: [
    { rule: "required", label: "Category Type" },
    {
      rule: "enum",
      values: ["housekeeping", "laundry", "inventory"],
      label: "Category Type",
    },
  ],
  in_laundry_quantity: [
    { rule: "required", label: "Laundry Quantity" },
    { rule: "numeric", label: "Laundry Quantity" },
    { rule: "minValue", value: 0, label: "Laundry Quantity" },
  ],
  // ready_quantity can be 0 on edit (all units in laundry is valid)
  ready_quantity: [
    { rule: "required", label: "Ready Quantity" },
    { rule: "numeric", label: "Ready Quantity" },
    { rule: "minValue", value: 0, label: "Ready Quantity" },
  ],
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: ["0", "1"], label: "Status" },
  ],
};

export const LaundryRules = {
  operated_by: [
    { rule: "required", label: "Operated By" },
    { rule: "number", label: "Operated By" },
  ],
  send_date: [{ rule: "required", label: "Send Date" }],
  received_date: [{ rule: "required", label: "Received Date" }],
};

export const HousekeepingRules = {
  room_ids: [{ rule: "required", label: "Room No" }],
  assigned_to: [
    { rule: "required", label: "Assigned To" },
    { rule: "number", label: "Assigned To" },
  ],
  assigned_by: [
    { rule: "required", label: "Assigned By" },
    { rule: "number", label: "Assigned By" },
  ],
  inventory_issued: [
    { rule: "required", label: "Inventory Issued" },
    { rule: "number", label: "Inventory Issued" },
  ],
  start_time: [{ rule: "required", label: "Start Date" }],
  end_time: [{ rule: "required", label: "End Date" }],
};

export const RoomInventoryUsageRules = {
  housekeeping_id: [
    { rule: "required", label: "Housekeeping" },
    { rule: "number", label: "Housekeeping" },
  ],
  room_no: [
    { rule: "required", label: "Room No" },
    { rule: "number", label: "Room No" },
  ],
  product_id: [
    { rule: "required", label: "Product" },
    { rule: "number", label: "Product" },
  ],
  quantity: [
    { rule: "required", label: "Quantity" },
    { rule: "number", label: "Quantity" },
  ],
};

export const RoomBookingFormRules = {
  // ── Reservation ────────────────────────────────────────────────────────────
  customer_id: [{ rule: "number", label: "Customer" }],
  checkin_date: [{ rule: "required", label: "Check In Date" }],
  checkout_date: [{ rule: "required", label: "Check Out Date" }],
  booking_type: [
    { rule: "required", label: "Booking Type" },
    { rule: "number", label: "Booking Type" },
  ],
  booking_reference: [
    { rule: "required", label: "Booking Reference" },
    { rule: "number", label: "Booking Reference" },
  ],
  booking_reference_no: [{ rule: "required", label: "Booking Reference No" }],

  // optional text fields — no required rule
  arrival_from: [{ label: "Arrival From" }],
  purpose_of_visit: [{ label: "Purpose of Visit" }],
  remarks: [{ label: "Remarks" }],

  // ── Rooms ──────────────────────────────────────────────────────────────────
  rooms: [{ rule: "required", label: "Rooms" }],

  // ── Billing (auto-calculated or conditional) ───────────────────────────────
  discount_reason: [{ label: "Discount Reason" }],
  offer_discount: [{ rule: "number", label: "Offer Discount" }],
  commission_percent: [{ rule: "number", label: "Commission Percent" }],
  commission_amount: [{ rule: "number", label: "Commission Amount" }],

  // ── Payment ────────────────────────────────────────────────────────────────
  payment_method: [
    { rule: "required", label: "Payment Method" },
    { rule: "number", label: "Payment Method" },
  ],
  total_amount: [
    { rule: "required", label: "Total Amount" },
    { rule: "number", label: "Total Amount" },
  ],

  // optional — only shown/enabled when payment_method is set
  advance_amount: [{ rule: "number", label: "Advance Amount" }],
  advance_remarks: [{ label: "Advance Remarks" }],

  // conditional — only shown when payment_method === 9 (bank transfer)
  bank_name: [{ label: "Bank Name" }],
  bank_account_number: [{ label: "Bank Account Number" }],
};



export const RoomBookingRoomRules = {
  // ── Reservation ────────────────────────────────────────────────────────────
  customer_id: [
    { rule: "required", label: "Customer" },
    { rule: "number", label: "Customer" },
  ],
  checkin_date: [{ rule: "required", label: "Check In Date" }],
  checkout_date: [{ rule: "required", label: "Check Out Date" }],
  // booking_type: [
  //   { rule: "required", label: "Booking Type" },
  //   { rule: "number", label: "Booking Type" },
  // ],
  // booking_reference: [
  //   { rule: "required", label: "Booking Reference" },
  //   { rule: "number", label: "Booking Reference" },
  // ],
  // booking_reference_no: [{ rule: "required", label: "Booking Reference No" }],

  // optional
  arrival_from: [{ label: "Arrival From" }],
  purpose_of_visit: [{ label: "Purpose of Visit" }],
  remarks: [{ label: "Remarks" }],

  // ── Rooms ──────────────────────────────────────────────────────────────────
  rooms: [{ rule: "required", label: "Rooms" }],

  // ── Billing (auto-calculated or conditional) ───────────────────────────────
  discount_reason: [{ label: "Discount Reason" }],
  offer_discount: [{ rule: "number", label: "Offer Discount" }],
  commission_percent: [{ rule: "number", label: "Commission Percent" }],
  commission_amount: [{ rule: "number", label: "Commission Amount" }],

  // ── Payment ────────────────────────────────────────────────────────────────
  payment_method: [
    { rule: "required", label: "Payment Method" },
    { rule: "number", label: "Payment Method" },
  ],
  total_amount: [
    { rule: "required", label: "Total Amount" },
    { rule: "number", label: "Total Amount" },
  ],

  // optional — enabled only when payment_method is set
  advance_amount: [{ rule: "number", label: "Advance Amount" }],
  advance_remarks: [{ label: "Advance Remarks" }],

  // conditional — only shown when payment_method === 9
  bank_name: [{ label: "Bank Name" }],
  bank_account_number: [{ label: "Bank Account Number" }],
};

export const RoomCheckinFormRules = {
  // ── Reservation ────────────────────────────────────────────────────────────
  customer_id: [
    { rule: "required", label: "Customer" },
    { rule: "number", label: "Customer" },
  ],
  checkin_date: [{ rule: "required", label: "Check In Date" }],
  checkout_date: [{ rule: "required", label: "Check Out Date" }],
  // booking_type: [
  //   { rule: "required", label: "Booking Type" },
  //   { rule: "number", label: "Booking Type" },
  // ],
  // booking_reference: [
  //   { rule: "required", label: "Booking Reference" },
  //   { rule: "number", label: "Booking Reference" },
  // ],
  // booking_reference_no: [{ rule: "required", label: "Booking Reference No" }],

  // optional
  arrival_from: [{ label: "Arrival From" }],
  purpose_of_visit: [{ label: "Purpose of Visit" }],
  remarks: [{ label: "Remarks" }],

  // ── Rooms ──────────────────────────────────────────────────────────────────
  rooms: [{ rule: "required", label: "Rooms" }],

  // ── Billing (auto-calculated or conditional) ───────────────────────────────
  discount_reason: [{ label: "Discount Reason" }],
  offer_discount: [{ rule: "number", label: "Offer Discount" }],
  commission_percent: [{ rule: "number", label: "Commission Percent" }],
  commission_amount: [{ rule: "number", label: "Commission Amount" }],

  // ── Payment ────────────────────────────────────────────────────────────────
  payment_method: [
    { rule: "required", label: "Payment Method" },
    { rule: "number", label: "Payment Method" },
  ],
  total_amount: [
    { rule: "required", label: "Total Amount" },
    { rule: "number", label: "Total Amount" },
  ],

  // optional — enabled only when payment_method is set
  advance_amount: [{ rule: "number", label: "Advance Amount" }],
  advance_remarks: [{ label: "Advance Remarks" }],

  // conditional — only shown when payment_method === 9
  bank_name: [{ label: "Bank Name" }],
  bank_account_number: [{ label: "Bank Account Number" }],
};

export const PoolPackageRules = {
  pool_package_name: [
    { rule: "required", label: "Package Name" },
    { rule: "minLength", value: 2, label: "Package Name" },
    { rule: "maxLength", value: 255, label: "Package Name" },
  ],
  pool_name_id: [
    { rule: "required", label: "Pool Name" },
    { rule: "numeric", label: "Pool Name" },
  ],
  price: [
    { rule: "required", label: "Price" },
    { rule: "float", label: "Price" },
    { rule: "minNumber", value: 0, label: "Price" },
  ],
  from_date: [{ rule: "required", label: "From Date" }],
  to_date: [{ rule: "required", label: "To Date" }],
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: ["0", "1", 0, 1], label: "Status" },
  ],
};

export const LaundryTaskRules = {
  // Task name — letters and spaces only (e.g. "Wash", "Dry Clean", "Iron")
  task_name: [
    { rule: "required", label: "Task Name" },
    { rule: "stringOnly", label: "Task Name" },
    { rule: "minLength", value: 2, label: "Task Name" },
    { rule: "maxLength", value: 100, label: "Task Name" },
  ],
  // 0 = Inactive, 1 = Active
  status: [
    { rule: "required", label: "Status" },
    { rule: "enum", values: ["0", "1"], label: "Status" },
  ],
};
export const LaundryItemCostRules = {};

export const FlightRules = {
  flight_number: [
    { rule: "required", label: "Flight Number" },
    {
      rule: "regex",
      value: /^[A-Z0-9]{2,10}$/,
      label: "Flight Number",
      message: "Flight number must be valid (e.g., AI101)",
    },
  ],
  airline_name: [
    { rule: "required", label: "Airline Name" },
    { rule: "minLength", value: 2, label: "Airline Name" },
    { rule: "maxLength", value: 100, label: "Airline Name" },
  ],
  reg_no: [
    { rule: "optional", label: "Registration Number" },
    {
      rule: "regex",
      value: /^[A-Z0-9-]{3,10}$/,
      label: "Registration Number",
      message: "Registration number must be valid (e.g., VT-ABC)",
    },
  ],
  fly_from: [
    { rule: "required", label: "Departure City" },
    { rule: "maxLength", value: 100, label: "Departure City" },
  ],
  fly_to: [
    { rule: "required", label: "Destination City" },
    { rule: "maxLength", value: 100, label: "Destination City" },
  ],
  departure: [{ rule: "required", label: "Departure Time" }],
  arrival: [{ rule: "required", label: "Arrival Time" }],
};

export const VehicleRules = {
  vehicle_number: [
    { rule: "required", label: "Vehicle Number" },
    { rule: "minLength", value: 2, label: "Vehicle Number" },
    { rule: "maxLength", value: 100, label: "Vehicle Number" },
    {
      rule: "regex",
      value: /^[A-Za-z0-9\s-]+$/,
      label: "Vehicle Number",
      message:
        "Vehicle number must contain only letters, numbers, spaces, or hyphens",
    },
  ],

  // Vehicle category (e.g. Sedan, SUV, Van, Bus)
  vehicle_type: [
    { rule: "required", label: "Vehicle Type" },
    { rule: "minLength", value: 2, label: "Vehicle Type" },
    { rule: "maxLength", value: 100, label: "Vehicle Type" },
  ],

  // Fuel category (e.g. Petrol, Diesel, Electric, Hybrid, CNG)
  fuel_type: [
    { rule: "required", label: "Fuel Type" },
    { rule: "stringOnly", label: "Fuel Type" },
    { rule: "minLength", value: 2, label: "Fuel Type" },
    { rule: "maxLength", value: 50, label: "Fuel Type" },
  ],

  // Number of passenger seats — integer between 1 and 100
  seat_capacity: [
    { rule: "required", label: "Seat Capacity" },
    { rule: "number", label: "Seat Capacity" },
    { rule: "minValue", value: 1, label: "Seat Capacity" },
    { rule: "maxValue", value: 100, label: "Seat Capacity" },
  ],
};

export const VehicleBookingRules = {
  booked_id: [{ rule: "required", label: "Room Booking" }],
  vehicle_id: [{ rule: "required", label: "Vehicle" }],
  flight_id: [{ rule: "required", label: "Flight" }],
  driver_id: [{ rule: "required", label: "Driver" }],
  transportation_type: [{ rule: "required", label: "Transportation Type" }],
  transportation_time: [{ rule: "required", label: "Transportation Time" }],
  cost: [
    { rule: "optional", label: "Cost" },
    { rule: "numeric", label: "Cost" },
  ],
  is_free: [{ rule: "optional", label: "Free Service" }],
};

export const PositionRules = {
  position_name: [
    { rule: "required", label: "Position Name" },
    { rule: "minLength", value: 2, label: "Position Name" },
    { rule: "stringOnly", label: "Position Name" },
  ],
};

export const DepartmentRules = {
  department_name: [
    { rule: "required", label: "Department Name" },
    { rule: "minLength", value: 2, label: "Department Name" },
    { rule: "stringOnly", label: "Department Name" },
  ],
};

export const DivisionRules = {
  division_name: [
    { rule: "required", label: "Division Name" },
    { rule: "minLength", value: 2, label: "Division Name" },
    { rule: "stringOnly", label: "Division Name" },
  ],
  department_id: [{ rule: "required", label: "Department" }],
};

export const ShiftRules = {
  shift_name: [
    {
      rule: "required",
      label: "Shift Name",
    },
    {
      rule: "stringOnly",
      label: "Shift Name",
    },
    {
      rule: "minLength",
      value: 2,
      label: "Shift Name",
    },
    {
      rule: "maxLength",
      value: 255,
      label: "Shift Name",
    },
  ],
  start_time: [
    {
      rule: "required",
      label: "Start Time",
    },
  ],
  end_time: [
    {
      rule: "required",
      label: "End Time",
    },
  ],
  shift_hours: [
    {
      rule: "required",
      label: "Shift Hours",
    },
    {
      rule: "number",
      label: "Shift Hours",
    },
  ],
};

export const RecruitmentRules = {
  first_name: [
    { rule: "required", label: "First Name" },
    { rule: "stringOnly", label: "First Name" },
    { rule: "minLength", value: 2, label: "First Name" },
    { rule: "maxLength", value: 100, label: "First Name" },
  ],

  last_name: [
    { rule: "required", label: "Last Name" },
    { rule: "stringOnly", label: "Last Name" },
    { rule: "minLength", value: 2, label: "Last Name" },
    { rule: "maxLength", value: 100, label: "Last Name" },
  ],

  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
  ],

  phone: [
    { rule: "required", label: "Phone" },
    { rule: "minLength", value: 7, label: "Phone" },
    { rule: "maxLength", value: 15, label: "Phone" },
  ],

  alternate_phone: [
    { rule: "optional", label: "Alternate Phone" },
    { rule: "minLength", value: 7, label: "Alternate Phone" },
    { rule: "maxLength", value: 15, label: "Alternate Phone" },
  ],

  ssn: [
    { rule: "optional", label: "SSN" },
    { rule: "ssn", label: "SSN" },
  ],

  state: [
    { rule: "optional", label: "State" },
    { rule: "maxLength", value: 100, label: "State" },
  ],

  city: [
    { rule: "optional", label: "City" },
    { rule: "stringOnly", label: "City" },
    { rule: "minLength", value: 2, label: "City" },
    { rule: "maxLength", value: 100, label: "City" },
  ],

  zip_code: [
    { rule: "optional", label: "Zip Code" },
    { rule: "numeric", label: "Zip Code" },
    { rule: "minLength", value: 4, label: "Zip Code" },
    { rule: "maxLength", value: 10, label: "Zip Code" },
  ],

  education: {
    degree_name: [
      { rule: "required", label: "Degree" },
      { rule: "minLength", value: 2, label: "Degree" },
      { rule: "maxLength", value: 100, label: "Degree" },
      {
        rule: "regex",
        value: /^[A-Za-z\s.]+$/,
        message: "Degree must only contain alphabets, dots and spaces",
        label: "Degree",
      },
    ],
    university_name: [
      { rule: "required", label: "University" },
      { rule: "minLength", value: 2, label: "University" },
      { rule: "maxLength", value: 200, label: "University" },
    ],
    cgpa: [
      { rule: "required", label: "CGPA" },
      { rule: "numeric", label: "CGPA" },
      { rule: "minNumber", value: 0, label: "CGPA" },
      { rule: "maxNumber", value: 10, label: "CGPA" },
      {
        rule: "regex",
        value: /^\d+(\.\d{1,2})?$/,
        message: "CGPA must have up to 2 decimal places",
        label: "CGPA",
      },
    ],
    comments: [
      { rule: "optional", label: "Comments" },
      { rule: "maxLength", value: 500, label: "Comments" },
    ],
  },

  experience: {
    company_name: [
      { rule: "required", label: "Company" },
      { rule: "minLength", value: 2, label: "Company" },
      { rule: "maxLength", value: 200, label: "Company" },
    ],
    position_title: [
      { rule: "required", label: "Position" },
      { rule: "minLength", value: 2, label: "Position" },
      { rule: "maxLength", value: 200, label: "Position" },
    ],
    start_date: [{ rule: "required", label: "Start Date" }],
    end_date: [{ rule: "required", label: "End Date" }],
    supervisor_name: [
      { rule: "required", label: "Supervisor Name" },
      { rule: "stringOnly", label: "Supervisor Name" },
      { rule: "minLength", value: 2, label: "Supervisor Name" },
      { rule: "maxLength", value: 100, label: "Supervisor Name" },
    ],
    supervisor_phone: [
      { rule: "required", label: "Supervisor Phone" },
      { rule: "minLength", value: 7, label: "Supervisor Phone" },
      { rule: "maxLength", value: 15, label: "Supervisor Phone" },
    ],
    duties: [
      { rule: "optional", label: "Duties" },
      { rule: "maxLength", value: 1000, label: "Duties" },
    ],
  },
};

export const CandidateShortlistRules = {
  candidate_id: [
    { rule: "required", label: "Candidate" },
    { rule: "numeric", label: "Candidate" },
  ],
  position_id: [
    { rule: "required", label: "Position" },
    { rule: "numeric", label: "Position" },
  ],
  shortlisted_date: [{ rule: "required", label: "Shortlisted Date" }],
  interview_datetime: [{ rule: "optional", label: "Interview Date & Time" }],
};

export const CandidateInterviewRules = {
  shortlist_id: [
    { rule: "required", label: "Candidate" },
    { rule: "numeric", label: "Candidate" },
  ],
  interview_date: [{ rule: "required", label: "Interview Date & Time" }],
  interviewer_id: [
    { rule: "required", label: "Interviewer ID" },
    { rule: "numeric", label: "Interviewer ID" },
  ],
  interview_marks: [{ rule: "optional", label: "Interview Marks" }],
  written_total_marks: [{ rule: "optional", label: "Written Total Marks" }],
  mcq_total_marks: [{ rule: "optional", label: "MCQ Total Marks" }],
  selection_status: [{ rule: "required", label: "Selection Status" }],
  recommendation: [{ rule: "optional", label: "Recommendation" }],
  remarks: [{ rule: "optional", label: "Remarks" }],
};

export const RosterRules = {
  roster_name: [
    { rule: "required", label: "Roster Name" },
    { rule: "minLength", value: 2, label: "Roster Name" },
    { rule: "maxLength", value: 100, label: "Roster Name" },
  ],
  shift_id: [{ rule: "required", label: "Shift" }],
  start_date: [{ rule: "required", label: "Start Date" }],
  end_date: [{ rule: "required", label: "End Date" }],
};

export const AssignRules = {
  roster_id: [{ rule: "required", label: "Roster" }],
};

export const CandidateSelectionRules = {
  can_id: [{ rule: "required", label: "Candidate" }],
  pos_id: [{ rule: "required", label: "Position" }],
  selection_terms: [{ rule: "optional", label: "Selection Terms" }],
};

export const WeeklyHolidayRules = {
  day_name: [{ rule: "required", label: "Day Name" }],
  is_holiday: [{ rule: "required", label: "Status" }],
};

export const HolidayRules = {
  holiday_name: [
    { rule: "required", label: "Holiday Name" },
    { rule: "stringOnly", label: "Holiday Name" },
    { rule: "minLength", value: 2, label: "Holiday Name" },
    { rule: "maxLength", value: 100, label: "Holiday Name" },
  ],
  start_date: [{ rule: "required", label: "Start Date" }],
  end_date: [{ rule: "required", label: "End Date" }],
  total_days: [{ rule: "required", label: "Number of Days" }],
};

export const LeaveTypeRules = {
  leave_type: [
    { rule: "required", label: "Leave Type" },
    { rule: "stringOnly", label: "Leave Type" },
    { rule: "minLength", value: 2, label: "Leave Type" },
    { rule: "maxLength", value: 50, label: "Leave Type" },
  ],
  leave_days: [
    { rule: "required", label: "Leave Days" },
    { rule: "numericOnly", label: "Leave Days" },
  ],
};

export const LeaveApplicationRules = {
  employee_id: [{ rule: "required", label: "Employee" }],
  leave_type_id: [{ rule: "required", label: "Leave Type" }],
  applied_start_date: [{ rule: "required", label: "Application Start Date" }],
  applied_end_date: [{ rule: "required", label: "Application End date" }],
  applied_days: [{ rule: "required", label: "Apply Day" }],
  reason: [
    { rule: "required", label: "Reason" },
    { rule: "minLength", value: 5, label: "Reason" },
  ],
};

export const EmployeeRules = {
  // Step 1: Basic Info
  first_name: [
    { rule: "required", label: "First Name" },
    { rule: "stringOnly", label: "First Name" },
    { rule: "minLength", value: 2, label: "First Name" },
  ],
  middle_name: [
    { rule: "optional", label: "Middle Name" },
    { rule: "stringOnly", label: "Middle Name" },
    { rule: "minLength", value: 2, label: "Middle Name" },
  ],
  last_name: [
    { rule: "required", label: "Last Name" },
    { rule: "stringOnly", label: "Last Name" },
    { rule: "minLength", value: 2, label: "Last Name" },
  ],
  maiden_name: [
    { rule: "optional", label: "Maiden Name" },
    { rule: "stringOnly", label: "Maiden Name" },
    { rule: "minLength", value: 2, label: "Maiden Name" },
  ],
  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
  ],
  phone: [
    { rule: "required", label: "Phone" },
    { rule: "minLength", value: 7, label: "Phone" },
    { rule: "maxLength", value: 15, label: "Phone" },
  ],
  alt_phone: [
    { rule: "optional", label: "Alternate Phone" },
    { rule: "minLength", value: 7, label: "Alternate Phone" },
    { rule: "maxLength", value: 15, label: "Alternate Phone" },
  ],
  country: [
    { rule: "optional", label: "Country" },
    { rule: "stringOnly", label: "Country" },
    { rule: "minLength", value: 2, label: "Country" },
    { rule: "maxLength", value: 100, label: "Country" },
  ],
  state: [
    { rule: "optional", label: "State" },
    { rule: "stringOnly", label: "State" },
    { rule: "minLength", value: 2, label: "State" },
    { rule: "maxLength", value: 100, label: "State" },
  ],
  city: [
    { rule: "optional", label: "City" },
    { rule: "stringOnly", label: "City" },
    { rule: "minLength", value: 2, label: "City" },
    { rule: "maxLength", value: 100, label: "City" },
  ],
  zip_code: [
    { rule: "optional", label: "Zip Code" },
    { rule: "minLength", value: 2, label: "Zip Code" },
    { rule: "maxLength", value: 100, label: "Zip Code" },
    { rule: "numeric", label: "Zip Code" },
  ],
  password: [{ rule: "password", label: "Password" }],
  username: [
    { rule: "optional", label: "Username" },
    { rule: "minLength", value: 2, label: "Username" },
    { rule: "maxLength", value: 15, label: "Username" },
  ],

  // Step 2: Position Info
  division_id: [{ rule: "required", label: "Division" }],
  position_id: [{ rule: "required", label: "Position" }],

  duty_type: [
    { rule: "required", label: "Duty Type" },
    {
      rule: "enum",
      label: "Duty Type",
      values: ["FULL_TIME", "PART_TIME", "CONTRACT"],
    },
  ],

  hire_date: [{ rule: "required", label: "Hire Date" }],

  original_hire_date: [{ rule: "optional", label: "Original Hire Date" }],

  home_department: [
    { rule: "optional", label: "Home Department" },
    { rule: "stringOnly", label: "Home Department" },
    { rule: "minLength", value: 2, label: "Home Department" },
    { rule: "maxLength", value: 100, label: "Home Department" },
  ],

  department_text: [
    { rule: "optional", label: "Department Text" },
    { rule: "minLength", value: 2, label: "Department Text" },
    { rule: "maxLength", value: 500, label: "Department Text" },
  ],

  salary: [
    { rule: "required", label: "Salary" },
    { rule: "numeric", label: "Salary" },
    { rule: "minNumber", value: 0, label: "Salary" },
  ],

  pay_frequency: [
    { rule: "required", label: "Pay Frequency" },
    {
      rule: "enum",
      label: "Pay Frequency",
      values: ["WEEKLY", "BIWEEKLY", "MONTHLY"],
    },
  ],

  pay_frequency_text: [
    { rule: "optional", label: "Pay Frequency Text" },
    { rule: "minLength", value: 2, label: "Pay Frequency Text" },
    { rule: "maxLength", value: 100, label: "Pay Frequency Text" },
  ],

  termination_date: [{ rule: "optional", label: "Termination Date" }],

  voluntary_termination: [
    { rule: "optional", label: "Voluntary Termination" },
    {
      rule: "enum",
      label: "Voluntary Termination",
      values: [1, 0],
    },
  ],

  rehire_date: [{ rule: "optional", label: "Rehire Date" }],

  termination_reason: [
    { rule: "optional", label: "Termination Reason" },
    { rule: "minLength", value: 2, label: "Termination Reason" },
    { rule: "maxLength", value: 100, label: "Termination Reason" },
  ],

  // Step 3: Benefits
  benefit_class_code: [
    { rule: "optional", label: "Benefit Class Code" },
    { rule: "minLength", value: 2, label: "Benefit Class Code" },
    { rule: "maxLength", value: 100, label: "Benefit Class Code" },
  ],

  benefit_accrual_date: [{ rule: "optional", label: "Benefit Accrual Date" }],

  benefit_status: [
    { rule: "optional", label: "Benefit Status" },
    {
      rule: "enum",
      label: "Benefit Status",
      values: ["ACTIVE", "INACTIVE"],
    },
  ],

  benefit_description: [
    { rule: "optional", label: "Benefit Description" },
    { rule: "minLength", value: 2, label: "Benefit Description" },
    { rule: "maxLength", value: 500, label: "Benefit Description" },
  ],

  // Step 4: Class
  class_code: [{ rule: "optional", label: "Class Code" }],

  class_status: [{ rule: "optional", label: "Class Status" }],

  // Step 5: Supervisor
  is_supervisor: [{ rule: "optional", label: "Is Supervisor" }],
  supervisor_employee_id: [{ rule: "optional", label: "Supervisor Name" }],

  // Step 6: Biographical
  date_of_birth: [{ rule: "optional", label: "Date of Birth" }],

  gender: [
    { rule: "optional", label: "Gender" },
    {
      rule: "enum",
      label: "Gender",
      values: ["MALE", "FEMALE", "OTHER"],
    },
  ],
  marital_status: [{ rule: "optional", label: "Marital Status" }],
  ssn: [{ rule: "optional", label: "SSN" }],
  citizenship: [{ rule: "optional", label: "Citizenship" }],

  // Step 7: Contacts
  home_email: [
    { rule: "optional", label: "Home Email" },
    { rule: "email", label: "Home Email" },
  ],

  business_email: [
    { rule: "optional", label: "Business Email" },
    { rule: "email", label: "Business Email" },
  ],

  home_phone: [{ rule: "optional", label: "Home Phone" }],

  business_phone: [{ rule: "optional", label: "Business Phone" }],

  cell_phone: [{ rule: "optional", label: "Cell Phone" }],

  // Step 8: Emergency Contact
  emergency_contact_name: [
    { rule: "optional", label: "Emergency Contact Name" },
  ],

  emergency_home_phone: [
    { rule: "optional", label: "Emergency Home Phone" },
    { rule: "minLength", value: 7, label: "Emergency Home Phone" },
    { rule: "maxLength", value: 15, label: "Emergency Home Phone" },
  ],

  emergency_work_phone: [
    { rule: "optional", label: "Emergency Work Phone" },
    { rule: "minLength", value: 7, label: "Emergency Work Phone" },
    { rule: "maxLength", value: 15, label: "Emergency Work Phone" },
  ],

  // Step 9: Custom fields (Repeatable)
  custom_fields: {
    field_name: [{ rule: "required", label: "Field Name" }],
    field_type: [{ rule: "required", label: "Field Type" }],
    field_value: [{ rule: "required", label: "Field Value" }],
  },
};

export const EmployeePerformanceRules = {
  employee_id: [
    { rule: "required", label: "Employee" },
    { rule: "numeric", label: "Employee" },
  ],
  review_date: [{ rule: "required", label: "Review Date" }],
  number_of_star: [
    { rule: "required", label: "Rating" },
    { rule: "number", label: "Rating" },
    { rule: "minNumber", value: 1, label: "Rating" },
    { rule: "maxNumber", value: 5, label: "Rating" },
  ],
  status: [
    { rule: "required", label: "Status" },
    {
      rule: "enum",
      values: ["pending", "approved", "rejected"],
      label: "Status",
    },
  ],
  note: [
    { rule: "required", label: "Review Note" },
    { rule: "minLength", value: 5, label: "Review Note" },
  ],
};

export const AwardRules = {
  award_name: [
    { rule: "required", label: "Award Name" },
    { rule: "minLength", value: 2, label: "Award Name" },
    { rule: "maxLength", value: 255, label: "Award Name" },
  ],
  gift_item: [
    { rule: "required", label: "Gift Item" },
    { rule: "minLength", value: 2, label: "Gift Item" },
    { rule: "maxLength", value: 255, label: "Gift Item" },
  ],
  award_date: [{ rule: "required", label: "Award Date" }],
  employee_id: [{ rule: "required", label: "Employee" }],
  award_by: [
    { rule: "required", label: "Award By" },
    { rule: "minLength", value: 2, label: "Award By" },
    { rule: "maxLength", value: 255, label: "Award By" },
  ],
};

export const GrandLoanRules = {
  employee_id: [
    { rule: "required", label: "Employee" },
    { rule: "numeric", label: "Employee" },
  ],
  permitted_by: [
    { rule: "required", label: "Permitted By" },
    { rule: "numeric", label: "Permitted By" },
  ],
  loan_details: [
    { rule: "optional", label: "Loan Details" },
    { rule: "maxLength", value: 1000, label: "Loan Details" },
  ],
  approve_date: [
    { rule: "required", label: "Approve Date" },
    { rule: "date", label: "Approve Date" },
  ],
  repayment_from: [
    { rule: "required", label: "Repayment From" },
    { rule: "date", label: "Repayment From" },
  ],
  total_amount: [
    { rule: "required", label: "Total Amount" },
    { rule: "float", label: "Total Amount" },
    { rule: "minNumber", value: 0.01, label: "Total Amount" },
  ],
  interest_percentage: [
    { rule: "required", label: "Interest Percentage" },
    { rule: "float", label: "Interest Percentage" },
    { rule: "minNumber", value: 0, label: "Interest Percentage" },
    { rule: "maxNumber", value: 100, label: "Interest Percentage" },
  ],
  installment_period_month: [
    { rule: "required", label: "Installment Period in Month" },
    { rule: "numeric", label: "Installment Period in Month" },
    { rule: "minNumber", value: 1, label: "Installment Period in Month" },
  ],
  status: [
    { rule: "required", label: "Status" },
    {
      rule: "enum",
      values: ["1", "2"],
      label: "Status",
    },
  ],
};

export const EmployeeSalaryPaymentRules = {
  employee_id: [
    { rule: "required", label: "Employee" },
    { rule: "numeric", label: "Employee" },
  ],
  total_salary: [
    { rule: "required", label: "Total Salary" },
    { rule: "float", label: "Total Salary" },
    { rule: "minNumber", value: 0, label: "Total Salary" },
  ],
  total_working_minutes: [
    { rule: "required", label: "Total Working Minutes" },
    { rule: "numeric", label: "Total Working Minutes" },
    { rule: "minNumber", value: 0, label: "Total Working Minutes" },
  ],
  working_period: [
    { rule: "required", label: "Working Period" },
    { rule: "maxLength", value: 50, label: "Working Period" },
  ],
  payment_due: [
    { rule: "required", label: "Payment Due Date" },
    { rule: "date", label: "Payment Due Date" },
  ],
  payment_date: [{ rule: "date", label: "Payment Date", optional: true }],
  paid_by: [
    { rule: "required", label: "Paid By" },
    { rule: "maxLength", value: 50, label: "Paid By" },
  ],
};

export const SalaryTypeRules = {
  sal_name: [
    { rule: "required", label: "Salary Name" },
    { rule: "minLength", value: 2, label: "Salary Name" },
  ],
  salary_type: [{ rule: "required", label: "Salary Type" }],
  default_amount: [
    { rule: "number", label: "Default Amount" },
    { rule: "min", value: 0, label: "Default Amount" },
  ],
  status: [{ rule: "required", label: "Status" }],
};

export const SalaryGenerateRules = {
  pay_frequency: [{ rule: "required", label: "Pay Frequency" }],
  salary_name: [
    { rule: "required", label: "Salary Batch Name" },
    { rule: "minLength", value: 3, label: "Salary Batch Name" },
  ],
  from: [{ rule: "required", label: "From Date" }],
  to: [{ rule: "required", label: "To Date" }],
  status: [{ rule: "required", label: "Status" }],
};

export const SalaryBatchUpdateRules = {
  salary_name: [
    { rule: "required", label: "Salary Batch Name" },
    { rule: "minLength", value: 3, label: "Salary Batch Name" },
  ],
  status: [{ rule: "required", label: "Status" }],
};

export const LoanInstallmentRules = {
  employee_id: [
    { rule: "required", label: "Employee Name" },
    { rule: "numeric", label: "Employee Name" },
  ],
  grand_loan_id: [
    { rule: "required", label: "Loan No" },
    { rule: "numeric", label: "Loan No" },
  ],
  installment_amount: [
    { rule: "required", label: "Installment Amount" },
    { rule: "float", label: "Installment Amount" },
  ],
  payment_amount: [
    { rule: "required", label: "Payment" },
    { rule: "float", label: "Payment" },
    { rule: "minNumber", value: 0.01, label: "Payment" },
  ],
  payment_date: [
    { rule: "required", label: "Date" },
    { rule: "date", label: "Date" },
  ],
  receiver_id: [
    { rule: "required", label: "Receiver" },
    { rule: "numeric", label: "Receiver" },
  ],
  installment_no: [
    { rule: "required", label: "Install No" },
    { rule: "numeric", label: "Install No" },
    { rule: "minNumber", value: 1, label: "Install No" },
  ],
  notes: [
    { rule: "optional", label: "Notes" },
    { rule: "maxLength", value: 1000, label: "Notes" },
  ],
};

export const HallBookingRules = {
  // Main booking fields
  customer_id: [
    { rule: "required", label: "Customer" }, // Optional if creating new customer
    { rule: "number", label: "Customer" },
    { rule: "min", value: 1, label: "Customer" },
  ],
  start_date: [{ rule: "required", label: "Start Date" }],
  end_date: [{ rule: "required", label: "End Date" }],
  event_name: [
    { rule: "required", label: "Event Name" },
    { rule: "stringOnly", label: "Event Name" },
    { rule: "minLength", value: 3, label: "Event Name" },
    { rule: "maxLength", value: 255, label: "Event Name" },
    { rule: "noSpecialChars", label: "Event Name" },
  ],
  event_type: [
    { rule: "required", label: "Event Type" },
    { rule: "stringOnly", label: "Event Type" },
    { rule: "minLength", value: 2, label: "Event Type" },
    { rule: "maxLength", value: 100, label: "Event Type" },
  ],
  payment_method_id: [
    { rule: "optional", label: "Payment Method" },
    { rule: "number", label: "Payment Method" },
    { rule: "min", value: 1, label: "Payment Method" },
  ],
  total_amount: [
    { rule: "required", label: "Total Amount" },
    { rule: "number", label: "Total Amount" },
    { rule: "min", value: 0, label: "Total Amount" },
    { rule: "max", value: 999999999, label: "Total Amount" },
  ],
  paid_amount: [
    { rule: "optional", label: "Paid Amount" },
    { rule: "number", label: "Paid Amount" },
    { rule: "min", value: 0, label: "Paid Amount" },
    { rule: "max", value: 999999999, label: "Paid Amount" },
  ],
  food_charge: [
    { rule: "optional", label: "Food Charge" },
    { rule: "number", label: "Food Charge" },
    { rule: "min", value: 0, label: "Food Charge" },
    { rule: "max", value: 999999999, label: "Food Charge" },
  ],
  booking_charge: [
    { rule: "optional", label: "Booking Charge" },
    { rule: "number", label: "Booking Charge" },
    { rule: "min", value: 0, label: "Booking Charge" },
    { rule: "max", value: 999999999, label: "Booking Charge" },
  ],
  remarks: [
    { rule: "optional", label: "Remarks" },
    { rule: "stringOnly", label: "Remarks" },
    { rule: "maxLength", value: 1000, label: "Remarks" },
    { rule: "noHtmlTags", label: "Remarks" },
  ],
  payment_remarks: [
    { rule: "optional", label: "Payment Remarks" },
    { rule: "stringOnly", label: "Payment Remarks" },
    { rule: "maxLength", value: 500, label: "Payment Remarks" },
    { rule: "noHtmlTags", label: "Payment Remarks" },
  ],
  // New customer validation (when customer_type is "new")
  new_customer: {
    first_name: [
      { rule: "required", label: "First Name" },
      { rule: "stringOnly", label: "First Name" },
      { rule: "minLength", value: 2, label: "First Name" },
      { rule: "maxLength", value: 255, label: "First Name" },
      { rule: "noSpecialChars", label: "First Name" },
    ],
    last_name: [
      { rule: "required", label: "Last Name" },
      { rule: "stringOnly", label: "Last Name" },
      { rule: "minLength", value: 2, label: "Last Name" },
      { rule: "maxLength", value: 255, label: "Last Name" },
      { rule: "noSpecialChars", label: "Last Name" },
    ],
    customer_phone: [
      { rule: "required", label: "Phone Number" },
      { rule: "numeric", label: "Phone Number" },
      { rule: "minLength", value: 10, label: "Phone Number" },
      { rule: "maxLength", value: 15, label: "Phone Number" },
    ],
    email: [
      { rule: "required", label: "Email" },
      { rule: "email", label: "Email" },
      { rule: "maxLength", value: 255, label: "Email" },
    ],
    gender: [
      { rule: "optional", label: "Gender" },
      { rule: "stringOnly", label: "Gender" },
      { rule: "enum", values: ["Male", "Female", "Other"], label: "Gender" },
    ],
    dob: [
      { rule: "optional", label: "Date of Birth" },
      { rule: "date", label: "Date of Birth" },
    ],
    anniversary: [
      { rule: "optional", label: "Anniversary" },
      { rule: "date", label: "Anniversary" },
    ],
    nationality: [
      { rule: "optional", label: "Nationality" },
      { rule: "stringOnly", label: "Nationality" },
      { rule: "maxLength", value: 100, label: "Nationality" },
    ],
    contact_type: [
      { rule: "optional", label: "Contact Type" },
      { rule: "stringOnly", label: "Contact Type" },
      { rule: "maxLength", value: 50, label: "Contact Type" },
    ],
    country: [
      { rule: "optional", label: "Country" },
      { rule: "stringOnly", label: "Country" },
      { rule: "maxLength", value: 100, label: "Country" },
    ],
    city: [
      { rule: "optional", label: "City" },
      { rule: "stringOnly", label: "City" },
      { rule: "maxLength", value: 100, label: "City" },
    ],
    zip_code: [
      { rule: "optional", label: "Zip Code" },
      { rule: "stringOnly", label: "Zip Code" },
      { rule: "maxLength", value: 20, label: "Zip Code" },
    ],
    address: [
      { rule: "optional", label: "Address" },
      { rule: "stringOnly", label: "Address" },
      { rule: "maxLength", value: 500, label: "Address" },
    ],
    pid_type: [
      { rule: "optional", label: "ID Type" },
      { rule: "stringOnly", label: "ID Type" },
      { rule: "maxLength", value: 50, label: "ID Type" },
    ],
    pid: [
      { rule: "optional", label: "ID Number" },
      { rule: "stringOnly", label: "ID Number" },
      { rule: "maxLength", value: 100, label: "ID Number" },
    ],
    profile_image: [
      { rule: "optional", label: "Profile Image" },
      {
        rule: "fileType",
        value: ["jpg", "jpeg", "png", "gif", "webp"],
        label: "Profile Image",
      },
      { rule: "maxFileSize", value: 5, label: "Profile Image" }, // 5MB max
    ],
    img_front: [
      { rule: "optional", label: "ID Front Image" },
      {
        rule: "fileType",
        value: ["jpg", "jpeg", "png", "gif", "webp"],
        label: "ID Front Image",
      },
      { rule: "maxFileSize", value: 5, label: "ID Front Image" }, // 5MB max
    ],
    img_back: [
      { rule: "optional", label: "ID Back Image" },
      {
        rule: "fileType",
        value: ["jpg", "jpeg", "png", "gif", "webp"],
        label: "ID Back Image",
      },
      { rule: "maxFileSize", value: 5, label: "ID Back Image" }, // 5MB max
    ],
  },
  // Halls array validation
  halls: {
    hallroom_type_id: [
      { rule: "required", label: "Hallroom Type" },
      { rule: "number", label: "Hallroom Type" },
      { rule: "min", value: 1, label: "Hallroom Type" },
    ],
    hall_room_no: [
      { rule: "optional", label: "Hall Room Number" },
      { rule: "stringOnly", label: "Hall Room Number" },
      { rule: "maxLength", value: 50, label: "Hall Room Number" },
    ],
    seatplan_id: [
      { rule: "required", label: "Seating Arrangement" },
      { rule: "number", label: "Seating Arrangement" },
      { rule: "min", value: 1, label: "Seating Arrangement" },
    ],
    capacity: [
      { rule: "required", label: "Number of Guests" },
      { rule: "number", label: "Number of Guests" },
      { rule: "min", value: 1, label: "Number of Guests" },
      { rule: "max", value: 9999, label: "Number of Guests" },
    ],
    hourly_rate: [
      { rule: "required", label: "Hall Rent Total" },
      { rule: "number", label: "Hall Rent Total" },
      { rule: "min", value: 0, label: "Hall Rent Total" },
      { rule: "max", value: 999999, label: "Hall Rent Total" },
    ],
    per_hour_rate: [
      { rule: "optional", label: "Per Hour Rate" },
      { rule: "number", label: "Per Hour Rate" },
      { rule: "min", value: 0, label: "Per Hour Rate" },
      { rule: "max", value: 999999, label: "Per Hour Rate" },
    ],
    include_hall_rent: [
      { rule: "optional", label: "Include Hall Rent" },
      { rule: "enum", values: ["0", "1"], label: "Include Hall Rent" },
    ],
    // Food package validation
    food_package_id: [
      { rule: "optional", label: "Food Package" },
      { rule: "number", label: "Food Package" },
      { rule: "min", value: 1, label: "Food Package" },
    ],
    food_price: [
      { rule: "optional", label: "Food Price" },
      { rule: "number", label: "Food Price" },
      { rule: "min", value: 0, label: "Food Price" },
      { rule: "max", value: 999999, label: "Food Price" },
    ],
    food_quantity: [
      { rule: "optional", label: "Food Quantity" },
      { rule: "number", label: "Food Quantity" },
      { rule: "min", value: 1, label: "Food Quantity" },
      { rule: "max", value: 9999, label: "Food Quantity" },
    ],
    // Selected foods validation - array of objects
    selected_foods: [{ rule: "optional", label: "Selected Foods" }],
  },
};

// =============================================================================
// *********************** FRONTEND VALIDATION RULES **************************
// =============================================================================

export const FrontendRegisterRules = {
  firstName: [
    { rule: "required", label: "First Name" },
    { rule: "minLength", value: 2, label: "First Name" },
    { rule: "maxLength", value: 100, label: "First Name" },
    { rule: "stringOnly", label: "First Name" },
  ],
  lastName: [
    { rule: "required", label: "Last Name" },
    { rule: "minLength", value: 2, label: "Last Name" },
    { rule: "maxLength", value: 100, label: "Last Name" },
    { rule: "stringOnly", label: "Last Name" },
  ],
  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
  ],
  password: [
    { rule: "required", label: "Password" },
    { rule: "password", label: "Password" },
  ],
  confirmPassword: [{ rule: "required", label: "Confirm Password" }],
};

export const FrontendLoginRules = {
  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
  ],
  password: [{ rule: "required", label: "Password" }],
};

export const ServiceLinksRules = [];

export const ContactSectionRules = {
  name: [
    { rule: "required", label: "Name" },
    { rule: "minLength", value: 2, label: "Name" },
    { rule: "maxLength", value: 100, label: "Name" },
  ],
  contact_number: [
    { rule: "required", label: "Contact Number" },
    {
      rule: "regex",
      value: /^[0-9+\-\s()]*$/,
      message:
        "Contact Number must contain only digits, spaces, and +()- characters",
    },
    { rule: "minLength", value: 7, label: "Contact Number" },
    { rule: "maxLength", value: 20, label: "Contact Number" },
  ],
  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
    { rule: "maxLength", value: 255, label: "Email" },
  ],
  special_requests: [
    { rule: "required", label: "Special Requests" },
    { rule: "minLength", value: 10, label: "Special Requests" },
    { rule: "maxLength", value: 1000, label: "Special Requests" },
  ],
};

export const NewsletterRules = {
  email: [
    { rule: "required", label: "Email" },
    { rule: "email", label: "Email" },
    { rule: "maxLength", value: 255, label: "Email" },
  ],
};

export const CheckoutCustomerRules = {
  firstName: [
    { rule: "required", label: "First Name" },
    { rule: "minLength", value: 2, label: "First Name" },
    { rule: "stringOnly", label: "First Name" },
    { rule: "noSpecialChars", label: "First Name" },
  ],
  lastName: [
    { rule: "required", label: "Last Name" },
    { rule: "minLength", value: 2, label: "Last Name" },
    { rule: "stringOnly", label: "Last Name" },
    { rule: "noSpecialChars", label: "Last Name" },
  ],
  email: [
    { rule: "required", label: "Email Address" },
    { rule: "email", label: "Email Address" },
  ],
  address: [
    { rule: "required", label: "Address" },
    { rule: "minLength", value: 5, label: "Address" },
    { rule: "noSpecialChars", label: "Address" },
  ],
  specialRequests: [
    { rule: "optional", label: "Special Requests" },
    { rule: "noSpecialChars", label: "Special Requests" },
  ],
};

export const BlogRules = {
  title: [
    { rule: "required", label: "Blog Title" },
    { rule: "minLength", value: 3, label: "Blog Title" },
    { rule: "maxLength", value: 255, label: "Blog Title" },
  ],
  category_id: [
    { rule: "required", label: "Category" },
    { rule: "numeric", label: "Category" },
  ],
  content: [
    { rule: "required", label: "Content" },
    { rule: "minLength", value: 10, label: "Content" },
  ],
  excerpt: [{ rule: "maxLength", value: 500, label: "Excerpt" }],
  is_active: [{ rule: "required", label: "Publish Status" }],
};

export const BlogCategoryRules = {
  name: [
    { rule: "required", label: "Category Name" },
    { rule: "minLength", value: 2, label: "Category Name" },
    { rule: "maxLength", value: 100, label: "Category Name" },
  ],
  sort_order: [{ rule: "numeric", label: "Sort Order" }],
  is_active: [{ rule: "required", label: "Status" }],
};

export const BlogTagRules = {
  name: [
    { rule: "required", label: "Tag Name" },
    { rule: "minLength", value: 2, label: "Tag Name" },
    { rule: "maxLength", value: 255, label: "Tag Name" },
  ],
  status: [{ rule: "required", label: "Status" }],
};

export const WhyChooseUsAddRules = {
  title: [
    { rule: "required", label: "Title" },
    { rule: "minLength", value: 2, label: "Title" },
    { rule: "maxLength", value: 255, label: "Title" },
  ],
  description: [
    { rule: "required", label: "Description" },
    { rule: "minLength", value: 10, label: "Description" },
  ],
};

export const AboutUsRules = [];
